module.exports = __webpack_public_path__ + "img/package.b5a6822f.png";